import React, { useCallback, useMemo } from 'react';
import { isSbsApp } from '../../../common/utils/passUtil';

const ScheduleItem = React.memo(
  ({
    jwt,
    smr_programid,
    channel_id,
    thumbnail,
    circle_image,
    date,
    time,
    title,
    labels,
    isLive,
    button,
    progress,
    isAlarmActive,
    onAlarmToggle,
  }) => {
    const handleClickAlarm = useCallback(
      (event) => {
        event.preventDefault();

        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'click',
          option: {
            clickName: '라이브/예약',
            clickType: 'NC',
            value1: title,
            value2: '',
            value3: '',
            value4: '',
            value5: '',
          },
        });

        if (isSbsApp()) {
          if (!jwt) {
            if (/android/i.test(window.navigator.userAgent)) {
              window.location.href = `intent://login?type=schedule&channelid=${channel_id}&date=${date}&img=${encodeURIComponent(
                circle_image
              )}&#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
            } else {
              window.location.href = `siapp://login?type=schedule&channelid=${channel_id}&date=${date}&img=${encodeURIComponent(
                circle_image
              )}`;
            }
          } else {
            if (/android/i.test(window.navigator.userAgent)) {
              window.location.href = `intent://schedule?channelid=${channel_id}&date=${date}&img=${encodeURIComponent(
                circle_image
              )}&programtitle=${encodeURIComponent(
                title
              )}#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
            } else {
              window.location.href = `siapp://schedule?channelid=${channel_id}&date=${date}&img=${encodeURIComponent(
                circle_image
              )}&programtitle=${encodeURIComponent(title)}`;
            }
          }

          onAlarmToggle(!isAlarmActive);
        } else {
          if (
            confirm(
              `라이브 예약은 앱에서만 가능합니다. 'SBS play' 에서 열겠습니까?`
            )
          ) {
            //alert('앱 연결 프로토콜 필요');
            window.location.href = 'siapp://home?tab=home';
          }
        }
      },
      [jwt, channel_id, date, isAlarmActive, onAlarmToggle]
    );

    const handleClickTimeMachine = useCallback(
      (event) => {
        event.preventDefault();

        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'click',
          option: {
            clickName: '라이브/타임머신',
            clickType: 'NC',
            value1: title,
            value2: '',
            value3: '',
            value4: '',
            value5: '',
          },
        });

        if (isSbsApp()) {
          if (!jwt) {
            if (/android/i.test(window.navigator.userAgent)) {
              window.location.href = `intent://login?type=timemachine&date=${date}&#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
            } else {
              window.location.href = `siapp://login?type=timemachine&date=${date}`;
            }
          } else {
            if (/android/i.test(window.navigator.userAgent)) {
              window.location.href = `intent://timemachine?date=${date}#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end`;
            } else {
              window.location.href = `siapp://timemachine?date=${date}`;
            }
          }
        } else {
          if (
            confirm(
              `타임머신 기능은 앱에서만 가능합니다. 'SBS play' 에서 열겠습니까?`
            )
          ) {
            //alert('앱 연결 프로토콜 필요');
            window.location.href = 'siapp://home?tab=home';
          }
        }
      },
      [jwt, date]
    );

    const renderedLabels = useMemo(
      () =>
        labels.map((label, index) => {
          const parsedLabel = parseInt(label);
          const displayLabel =
            !isNaN(parsedLabel) && parsedLabel >= 19 ? '19+' : label;
          const colorClass =
            label === '보라' || (parsedLabel >= 19 && !isNaN(parsedLabel))
              ? 'f_color01'
              : '';

          return (
            <li key={index}>
              <div className={`schedule_label_cont ${colorClass}`}>
                <span className="schedule_label">
                  <span className="text">{displayLabel}</span>
                </span>
              </div>
            </li>
          );
        }),
      [labels]
    );

    return (
      <div className={`schedule_program_w ${isLive ? 'type_live' : ''}`}>
        <div className="schedule_program_inner">
          <div className="schedule_program_cont">
            <span className="time">{time}</span>
            {isLive && (
              <div className="thumbnail">
                <span className="ico_live">
                  <i className="ir">live</i>
                </span>
                <img
                  src={thumbnail}
                  alt="라이브 썸네일"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            )}
            <div className="title_w">
              <strong className="title_cont">{title}</strong>
              <ul className="schedule_label_list01">{renderedLabels}</ul>
            </div>
          </div>
          {button === 'dvr' && !isLive && (
            <a onClick={handleClickTimeMachine} className="btnIcon01_time">
              <span className="ico_time">
                <i className="ir">타임머신</i>
              </span>
            </a>
          )}
          {button === 'alarm' && (
            <button
              id={`alarm_${channel_id}_${date}`}
              type="button"
              onClick={handleClickAlarm}
              className={`btnIcon01_alarm_toggle ${
                isAlarmActive ? 'active' : ''
              }`}
            >
              <span className="ico_alarm_on">
                <i className="ir">알림 받기 중</i>
              </span>
              <span className="ico_alarm_off">
                <i className="ir">알림 받기 전</i>
              </span>
            </button>
          )}
        </div>
        {isLive && (
          <div className="progressbar_w01">
            <span className="graph" style={{ width: `${progress}%` }}>
              <i className="ir">{progress}%</i>
            </span>
          </div>
        )}
      </div>
    );
  }
);

export default ScheduleItem;
